<template>
  <div class="inputFieldContainer mb-6">
    <div class="d-flex justify-space-between inputFieldLabels">
      <div>
        <span class="pl-1 inputFieldLabel mr-4" :class="{ asterisk: !optional && label }">{{label}}</span>
        <v-tooltip v-if="tooltip" top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
            >
              {{tooltipIcon}}
            </v-icon>
          </template>
          <span>{{tooltip}}</span>
        </v-tooltip>
      </div>
      <span v-if="showRequirementLabels">
        <!-- LSC-162905: remove optional -->
        <!-- <span v-if="optional" class="pr-1 inputFieldLabel small">({{$t('optional')}})</span> -->
        <span v-if="requiredErrorState" class="pr-1 inputFieldRequiredLabel">{{$t('obligatory')}}</span>
      </span>
    </div>
    <v-text-field v-if="!nativeInput" ref="input" class="mt-1 inputField"
        v-model="inputValue" 
        v-bind="$attrs"
        :type="type"
        :label="label"
        :placeholder="placeHolder || ' '"
        :rules="rules"
        :error-messages="errorMessages"
        :hide-details="requiredErrorState ? true : 'auto'"
        :readonly="readonly"
        outlined
        dense
        single-line
        :prepend-inner-icon="prependIcon"
        @blur="$emit('blur')"
        @keydown="$emit('keydown', $event)"
        @update:error="$emit('errorupdate', $event)">
          <template v-slot:append>
              <v-progress-circular
                v-if="isLoading"
                size="20"
                width="2"
                indeterminate
                color="black"
              ></v-progress-circular>
              <v-icon v-if="!isLoading && validState && !readonly" class="appendIcon inputIcon">
                {{'$check'}}
              </v-icon>
          </template>
      </v-text-field>
    <div v-else class="d-flex">
      <slot name="selector"/>
      <div class="nativeInputContainer">
        <div class="nativeInputBorder" :class="dynamicClass">
          <div class="nativeInputBorder_inner d-flex">
            <v-icon v-if="prependIcon">
              {{prependIcon}}
            </v-icon>
            <input  ref="input" class="nativeInput" :class="{ native_error: nativeError }"
              v-model="inputValue" 
              v-bind="$attrs"
              :type="type"
              @blur="inputFocused = false;$emit('blur');"
              @keydown="$emit('keydown', $event)"
              @focus="inputFocused=true">
            <v-icon v-if="validState && !readonly" class="appendIcon">
              {{'$check'}}
            </v-icon>
          </div>
        </div>
        <div v-if="nativeError"
          class="nativeInput_error">
          {{nativeError}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {VTextField, VTooltip, VIcon, VProgressCircular} from 'vuetify/lib'
  export default {
    name: 'InputField',
    components: {
      VTextField,
      VTooltip,
      VIcon,
      VProgressCircular
    },
    props: {
      value: {
        type: [String, Number], default: null
      },
      type: {
        type: String,
        default: 'text'
      },
      label: {
        type: String,
        default: 'Label'
      },
      placeHolder: {
        type: String,
        default: ''
      },
      rules: {},
      errorMessages: {
        type: Array,
        default: () => []
      },
      prependIcon: {
        type: String,
        default: ''
      },
      optional: {
        type: Boolean,
        default: false
      },
      tooltip: {
        type: String,
        default: ''
      },
      tooltipIcon: {
        type: String,
        default: '$helpcircleoutline'
      },
      nativeInput: {
        type: Boolean,
        default: false
      },
      isLoading: {
        type: Boolean,
        default: false
      },
      readonly: {
        type: Boolean,
        default: false
      },
      showRequirementLabels: {
        type: Boolean,
        default: true
      }
    },
    mounted: function () {
      this.isValid = this.$refs.input.valid
      if (this.rules) {
        this.$watch(() => this.$refs.input.valid, (val) => {
          this.isValid = val
        })
      }
      else if (this.errorMessages) {
        this.$watch(() => this.errorMessages, (val) => {
          this.isValid = val.length === 0
        })
      }
      if (this.value &&this.$refs.input.validate) this.$refs.input.validate(true)
    },
    computed: {
      inputValue: {
        get () {
          return this.value
        },
        set (value) {
          this.firstInput = true
          this.$emit('input', value)
        }
      },
      requiredErrorState: function () {
        return this.showRequirementLabels && this.firstInput && !this.isValid && !this.inputValue
      },
      validState: function () {
        return this.isValid && !!this.inputValue
      },
      nativeError: function () {
        if (this.errorMessages && this.errorMessages.length) return this.errorMessages[0]
        else return null
      },
      dynamicClass: function () {
        return (this.inputFocused ? 'focus' : '') + ' ' + (this.nativeError ? 'native_error' : '')
      }
    },
    data() {
      return {
        isValid: true,
        firstInput: false, // serves to allow requiredErrorState only after the first user input
        inputFocused: false
      }
    }
  }
</script>